<template>
  <div class="invoice-detail">
    <div class="top">
      <div class="money">{{ info.amt || 0 | formatMoney }}</div>
      <div class="text">申请开票金额</div>
    </div>
    <div class="list">
      <div class="item">
        <div class="left">发票金额</div>
        <div class="right">{{ info.invoiceAmt || 0 | formatMoney }}</div>
      </div>
      <div class="item">
        <div class="left">发票类型</div>
        <div class="right">增值专用发票</div>
      </div>
      <!-- <div class="item">
        <div class="left">发票代码</div>
        <div class="right">{{ info.invoiceCode }}</div>
      </div>
      <div class="item">
        <div class="left">发票日期</div>
        <div class="right">
          {{ info.invoiceDate || '无' | dateFormat('YYYY-mm-dd HH:MM') }}
        </div>
      </div> -->
      <div class="item">
        <div class="left">发票编号</div>
        <div class="right">{{ info.invoiceNumber }}</div>
      </div>
      <div class="item">
        <div class="left">状态</div>
        <div class="right">{{ info.auditStatus | filterStatus }}</div>
      </div>
      <div class="item">
        <div class="left">快递公司</div>
        <div
          class="right special"
          @click="goFillExpress"
          v-if="info.paperFlag === 1 && !info.expressName"
        >
          去填写 >>
        </div>
        <div v-else>{{ info.expressName }}</div>
      </div>
      <div class="item">
        <div class="left">快递单号</div>
        <div class="right">{{ info.expressNumber }}</div>
      </div>
      <div class="item">
        <div class="left">申请时间</div>
        <div class="right">
          {{ info.createTime || '无' | dateFormat('YYYY-mm-dd HH:MM') }}
        </div>
      </div>
      <div class="item">
        <div class="left">审核时间</div>
        <div class="right">
          {{ info.auditTime || '无' | dateFormat('YYYY-mm-dd HH:MM') }}
        </div>
      </div>
      <div class="item">
        <div class="left">出款时间</div>
        <div class="right">
          <!-- {{ info.invoiceOutDate || '无' | dateFormat('YYYY-mm-dd HH:MM') }} -->
          线下出款
        </div>
      </div>
      <div class="item">
        <div class="left">审核描述</div>
        <div class="right">{{ info.auditDesc }}</div>
      </div>
      <div
        class="item"
        v-if="info.statement && JSON.stringify(info.statement) !== '{}'"
      >
        <div class="left">结算单</div>
        <div class="right special" @click="viewStatement">查看 >></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchInvoiceInfo } from '@/api/invoice/invoice'
import {
  WSBridge,
  platformAgent,
  formatMoney,
  dateFormat,
  jiemi
} from '@/utils/utils'
export default {
  data() {
    return {
      id: this.$route.query.invoiceId || '',
      info: {}
    }
  },
  filters: {
    formatMoney,
    dateFormat,
    filterStatus(val) {
      if (1 === val) {
        return '提交成功，待确认发票'
      } else if (2 === val) {
        return '发票审核通过，等待财务发放'
      } else if (3 === val) {
        return '发票审核不通过，请重新提交'
      } else if (4 === val) {
        return '已出款'
      } else if (5 === val) {
        return '部分出款'
      }
      return ''
    }
  },
  created() {
    SyHybridSdk.setNavigationBarTitle({
      params: {
        title: '发票详情'
      },
      success: res => {}
    })
    if (this.id === '') {
      alert('缺少参数')
      return
    }
    this.init()
  },
  methods: {
    init() {
      fetchInvoiceInfo({
        action: 'getInvoiceInfo',
        id: this.id
      }).then(result => {
        console.log(result)
        this.info = result || {}
      })
      return
      let result = WSBridge.nativeHttpEncrypt({
        params: {
          action: 'getInvoiceInfo',
          id: this.id
        },
        success: res => {
          this.getEncryptParams(res)
        }
      })
      if (platformAgent() == 'android') {
        this.getEncryptParams(result)
      }
    },
    getEncryptParams(result) {
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      let headers = result.headers
      if (typeof headers == 'string') {
        headers = JSON.parse(headers)
      }
      this.$store.commit('SET_QUERYS', headers)
      let body = result.body
      if (typeof body == 'string') {
        body = JSON.parse(body)
      }
      let token = result.token
      fetchInvoiceInfo(body).then(
        res => {
          if (!res) {
            return
          }
          let params = token + '#' + JSON.stringify(res)
          let ret = WSBridge.nativeHttpDecrypt({
            params,
            success: res => {
              this.getDecryptResult(res)
            }
          })
          if (platformAgent() == 'android') {
            this.getDecryptResult(ret)
          }
        },
        err => {
          alert('err: ' + err)
        }
      )
    },
    getDecryptResult(result) {
      result = jiemi(result)
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      this.info = result.data || {}
    },
    goFillExpress() {
      let params = {}
      if (platformAgent() == 'android') {
        params = {
          hostName:
            'com.jiuhongpay.worthplatform.mvp.ui.activity.UpdateCourierInfoActivity',
          INVOICEID: this.id.toString(),
          INVOICEAMT: this.info.invoiceAmt.toString()
        }
      } else if (platformAgent() == 'ios') {
        params = {
          hostName: 'ExpressInformationViewController',
          invoiceId: this.id,
          invoiceDic: this.info
        }
      }
      const self = this
      SyHybridSdk.openOriActivity({
        params: params,
        success: res => {
          if (res) {
            self.init()
          }
        }
      })
    },
    viewStatement() {
      this.$router.push({
        path: '/invoice-statement-list',
        query: {
          statement: this.info.statement || {}
        }
      })
    }
  }
}
</script>
